import React from "react";
import RefreshIco from "../../assets/Refresh.svg";
import { useLocation, useNavigate } from "react-router-dom";

const OutdatedValuation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  //const iframeKey = searchParams.get("key");
  const iframeKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE3MDMxNjM4OTcsInN1YiI6Imphdmllci5hbG9uc28rYWxpc2VkYUB1ZGFyZWFsZXN0YXRlLmNvbSIsInNjb3BlIjpbImNhbGN1bGF0b3IiXX0.x8FNhUWxHvK09K2fUX2F7Q2hL9WnHDSan1MZvxLswt4";
  const valuationId = searchParams.get("valuation_uid");

  const handleSeeValuation = () => {
    navigate(`/modelUDA?key=${iframeKey}&valuation_uid=${valuationId}`)
  }


  return (
    <main className="flex flex-col justify-center items-center w-full font-roboto">
      <article className="flex flex-col items-center justify-center mobile:w-1/2 w-5/6 space-y-8">
        <img
          className="h-8 w-8"
          src={RefreshIco}
          alt="Logo de Refresh"
        />
        <span className="text-center space-y-5">
          <h1 className="text-4xl text-[#212632] font-bold">
            Actualiza tu valoración, descubre el valor actual
          </h1>
          <h3 className="text-[#747D93] font-bold">
            La valoracion anterior ya no esta disponible debido a la constante varibilidad del mercado
            inmobiliario.  Para asegurarnos que tengas la información mas precisa, te invitamos a realizar una
            nueva valoracion.  Descubre el valor actual de tu propiedad.
          </h3>
        </span>
        <button
              type="button"
              className="border border-[#DE0E48] bg-[#DE0E48] hover:bg-[#9E0A33] hover:border-[#9E0A33] tablet:rounded-full rounded-lg tablet:w-60 w-full py-3"
              onClick={() => handleSeeValuation()}
            >
              <span className="text-white">Realizar nueva valoración</span>
            </button>
      </article>
    </main>
  );
};

export default OutdatedValuation;
